import { Injectable } from '@angular/core';
import {
  EntityCollectionServiceBase,
  EntityCollectionServiceElementsFactory
} from '@ngrx/data';

import { GrupoEspecie } from './grupos-especie.model';

@Injectable({ providedIn: 'root' })
export class GruposEspecieService extends EntityCollectionServiceBase<GrupoEspecie> {
  constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory) {
    super('GrupoEspecie', serviceElementsFactory);
  }
}